import type { NavSection } from "@/lib/routes";
import {
	BarChart3,
	BookOpen,
	Bot,
	Building2,
	Coins,
	Fuel,
	Gavel,
	Landmark,
	ArrowLeftRight,
	Droplets,
	Radio,
	Scale,
	Sparkles,
	UserRound,
	Vault,
	Wallet,
	PiggyBank,
	Wrench,
	type LucideIcon,
} from "lucide-react";

const MAP: Record<NavSection["icon"], LucideIcon> = {
	borrow: Coins,
	vaults: Vault,
	liquidate: Gavel,
	analytics: BarChart3,
	treasury: Landmark,
	governance: Scale,
	wallet: Wallet,
	savings: PiggyBank,
	pegswap: ArrowLeftRight,
	liquidity: Droplets,
	oracle: Radio,
	cycles: Fuel,
	profile: UserRound,
	docs: BookOpen,
	agents: Bot,
	skills: Wrench,
	intelligence: Sparkles,
	explore: BarChart3,
	institutions: Building2,
	more: Coins,
};

/** Soft accent within green-sovereign family (CSS color strings). */
const ACCENT: Record<NavSection["icon"], string> = {
	borrow: "var(--color-primary)",
	vaults: "var(--color-primary-dim)",
	liquidate: "#f59e0b",
	analytics: "var(--color-primary)",
	treasury: "var(--color-primary-hover)",
	governance: "var(--color-primary)",
	wallet: "var(--color-primary-dim)",
	savings: "var(--color-primary)",
	pegswap: "var(--color-primary-hover)",
	liquidity: "var(--color-primary-dim)",
	oracle: "var(--color-primary)",
	cycles: "#34d399",
	profile: "var(--color-primary)",
	docs: "#14b8a6",
	agents: "#eab308",
	skills: "#a3e635",
	intelligence: "var(--color-primary-hover)",
	explore: "var(--color-primary)",
	institutions: "var(--color-primary-dim)",
	more: "var(--color-primary)",
};

export function navIcon(icon: NavSection["icon"]): LucideIcon {
	return MAP[icon] ?? Coins;
}

export function navIconAccent(icon: NavSection["icon"]): string {
	return ACCENT[icon] ?? "var(--color-primary)";
}
